import { useEffect, useState, useRef } from 'react';
import { useMousePosition } from '../controller/useMousePosition';

//ΔVΔVΔ: Wrapper component for dragging and positioning
const DragContainer = (props) => {
    const { className, pose = { x: 0, y: 0 }, offset = { x: 0, y: 0 }, children, dragging = true, onMove = () => {}, verbose = false, updateWhenScrolled = false } = props;
    const dragRef = useRef();
    const mousePosition = useMousePosition();
    const [containerPose, setContainerPose] = useState(() => pose);
    const [winScrollY, setWinScrollY] = useState(0);

    const calculateBounds = () => {
        const outerRect = dragRef.current.getBoundingClientRect();
        const contentRect = dragRef.current.querySelector('.drag-container').getBoundingClientRect();
        const minX = outerRect.x;
        const minY = outerRect.y;
        const maxX = outerRect.right - contentRect.width;
        const maxY = outerRect.bottom - contentRect.height;

        return { minX, minY, maxX, maxY };
    };
    useEffect(() => {
        window.addEventListener('scroll', () => {
            setWinScrollY(Math.floor(window.scrollY));
        });
    }, []);

    useEffect(() => {
        if (updateWhenScrolled) {
            const coords = Object.assign({}, containerPose);
            const adjustedCoords = calculateCoords(coords, false);
            const nextCoords = { x: coords.x, y: adjustedCoords.y };
            if (className === 'download-window') console.log('&&& scroll updated: ', winScrollY, 'coords', nextCoords);
            setContainerPose(adjustedCoords);
        }
    }, [winScrollY]);

    const calculateCoords = ({ x, y }, useOffset = true) => {
        const bounds = calculateBounds();
        const coords = { x: x || 0, y: y || 0 };
        if (useOffset) {
            coords.x += offset.x;
            coords.y += offset.y;
        }

        coords.x = Math.max(coords.x, bounds.minX); //dont' drag too far left
        coords.y = Math.max(coords.y, bounds.minY); //don't drag too far up

        coords.x = Math.min(coords.x, bounds.maxX); //don't drag too far right
        coords.y = Math.min(coords.y, bounds.maxY); //don't drag too far down
        return coords;
    };
    useEffect(() => {
        var calcCoords = calculateCoords(pose);
        setContainerPose(calcCoords);
    }, [JSON.stringify(pose)]);

    useEffect(() => {
        if (dragging) {
            const coords = calculateCoords(mousePosition);
            setContainerPose(coords);
            onMove(coords, dragRef.current.getBoundingClientRect());
        }
    }, [JSON.stringify(mousePosition)]);

    return (
        <div ref={dragRef} className={'drag-bounds ' + className}>
            <div className={'drag-container'} style={{ left: containerPose.x, top: containerPose.y }}>
                {children}
            </div>
        </div>
    );
};

export default DragContainer;
